
      import { initModelCaseSelector, generateProposalPdf, loadModelCases } from './src/proposal_pdf.js';
      import { api } from './src/api.js';

      const sel = document.getElementById('case-select');
      const statusEl = document.getElementById('status');
      const previewEl = document.getElementById('preview');

      try {
        await initModelCaseSelector(sel);
        statusEl.textContent = `モデルケース ${sel.options.length - 1} 件 読込完了`;
        statusEl.className = 'status ok';
      } catch (e) {
        statusEl.textContent = 'モデルケース読込失敗: ' + e.message;
        statusEl.className = 'status err';
      }

      sel.addEventListener('change', async () => {
        if (!sel.value) { previewEl.style.display = 'none'; return; }
        const data = await loadModelCases();
        const c = data.cases.find(x => x.id === sel.value);
        if (!c) return;
        const prop = c.proposal || {};
        const econ = c.economics || {};
        previewEl.style.display = 'block';
        previewEl.innerHTML = `
          <div style="font-weight:600;margin-bottom:8px;">${c.label}</div>
          <div class="stats">
            <div class="stat"><div class="stat-label">PV容量</div><div class="stat-value">${prop.pv_kw || '-'} kW</div></div>
            <div class="stat"><div class="stat-label">蓄電池</div><div class="stat-value">${prop.battery_kwh || 0} kWh</div></div>
            <div class="stat"><div class="stat-label">回収年</div><div class="stat-value">${econ.payback_years || '-'} 年</div></div>
            <div class="stat"><div class="stat-label">初期費用</div><div class="stat-value">¥${(econ.initial_cost_jpy || 0).toLocaleString()}</div></div>
            <div class="stat"><div class="stat-label">補助金</div><div class="stat-value">¥${(econ.subsidy_jpy || 0).toLocaleString()}</div></div>
            <div class="stat"><div class="stat-label">年間節約</div><div class="stat-value">¥${(econ.annual_saving_jpy || 0).toLocaleString()}</div></div>
          </div>
        `;
      });

      document.getElementById('pdf-form').addEventListener('submit', async (e) => {
        e.preventDefault();
        const fd = new FormData(e.target);
        const caseId = fd.get('case_id');
        if (!caseId) return;
        const btn = document.getElementById('gen-btn');
        btn.disabled = true; btn.textContent = '生成中...';
        statusEl.textContent = 'PDF生成中（数秒）...';
        statusEl.className = 'status';
        try {
          const filename = await generateProposalPdf(caseId, {
            customerName: fd.get('customer_name') || '',
            staffName: fd.get('staff_name') || '',
          });
          statusEl.textContent = `生成完了: ${filename} (ブラウザのダウンロードフォルダ)`;
          statusEl.className = 'status ok';
        } catch (err) {
          statusEl.textContent = 'PDF生成失敗: ' + err.message;
          statusEl.className = 'status err';
        } finally {
          btn.disabled = false; btn.textContent = 'PDF生成（保存）';
        }
      });

      document.getElementById('save-history-btn').addEventListener('click', async () => {
        const caseId = sel.value;
        if (!caseId) { statusEl.textContent = 'モデルケース未選択'; statusEl.className = 'status err'; return; }
        const data = await loadModelCases();
        const c = data.cases.find(x => x.id === caseId);
        const fd = new FormData(document.getElementById('pdf-form'));
        try {
          const r = await api.saveDiagnosis({
            mode: c.segment === '住宅' ? 'home' : c.segment === '法人' ? 'corporate' : 'industry',
            title: `${fd.get('customer_name') || ''} ${c.label}`.trim(),
            inputs_json: c.customer || {},
            results_json: { proposal: c.proposal, economics: c.economics, subsidy: c.subsidy, environment: c.environment },
            recommended_kw: c.proposal?.pv_kw,
            annual_saving_jpy: c.economics?.annual_saving_jpy,
            payback_years: c.economics?.payback_years,
          });
          statusEl.textContent = `診断履歴に保存しました (id=${r.id})`;
          statusEl.className = 'status ok';
        } catch (err) {
          statusEl.textContent = '履歴保存失敗: ' + err.message;
          statusEl.className = 'status err';
        }
      });
    